import { render, staticRenderFns } from "./loading-item.vue?vue&type=template&id=21a01de2&scoped=true&"
import script from "./loading-item.vue?vue&type=script&lang=js&"
export * from "./loading-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a01de2",
  null
  
)

export default component.exports